export default
{
    path: '/',
    name: 'MainPage',
    component: () => import('../views/main/index.vue'),
    children:[
      {
        path: '/index.html',
        name: '/index.html',
        component: () => import('../views/main/homePage.vue')
        
      },
      {
        path: "/",
        name: "main",
        component: () => import('../views/main/homePage.vue'),
      },
      {
        path: "news",
        name: "news",
        component: () => import('../views/main/news/newsList.vue'),
      },
      {
        path: "newsDetail",
        name: "newsDetail",
        component: () => import('../views/main/news/newsDetail.vue'),
      },
      {
        path: "InvestorRelations",
        name: "InvestorRelations",
        component: () => import('../views/main/investor/investor.vue'),
      },
      {
        path: "society",
        name: "society",
        component: () => import('../views/main/society/society.vue'),
        
      },
      {
        path: "aboutus",
        name: "aboutus",
        component: () => import('../views/main/aboutus/aboutUs.vue'),
        
      },
      {
        path: "joinus",
        name: "joinus",
        component: () => import('../views/main/joinus/joinUs.vue'),
        
      },
      {
        path: "recruitDetail",
        name: "recruitDetail",
        component: () => import('../views/main/joinus/RecruitDetail.vue'),
        
      },
      {
        path: "recruit",
        name: "recruit",
        component: () => import('../views/main/joinus/RecruitList.vue'),
        
      }
      ,
      {
        path: "netprivate",
        name: "netprivate",
        component: () => import('../views/main/footer/privacyPolicy.vue'),
      }
      ,
      {
        path: "introduction",
        name: "introduction",
        component: () => import('../views/main/introduction/introduction.vue'),
      }
    ]
  }